import {
    FaStar,
   
    FaPlus,
  } from "react-icons/fa";
  import React, { useEffect, useMemo, useRef, useState } from "react";
  import { apiClient } from "../../api";
  import { baseUrl } from "../../Environments/environment";
  import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
  import { toast } from "react-toastify";
  import MilestoneModal from "./MilestoneModal";
  import MilestoneCard from "./MilestoneCard";
  import MilestoneSkeleton from "./MilestoneSkeleton";
  
  export function calculateRequiredReviews(R0, N0, T) {
    if (T >= 5) return 0;
    return Math.ceil(((T - R0) * N0) / (5 - T));
  }
  
  export function calculateEstimatedRequests(
    requiredReviews,
    conversionRate = 0.2
  ) {
    return Math.ceil(requiredReviews / conversionRate);
  }
  
  const CONVERSION_RATE = 0.2;
  
  export function calculateRequiredFiveStar(
    currentRating,
    currentReviewCount,
    targetRating
  ) {
    if (targetRating <= currentRating || targetRating >= 5) return 0;
  
    return Math.ceil(
      ((targetRating - currentRating) * currentReviewCount) / (5 - targetRating)
    );
  }
  
  export function calculateLinksToSend(requiredFiveStar) {
    return Math.ceil(requiredFiveStar / CONVERSION_RATE);
  }
  
  function enrichUpcomingMilestone(
    targetRating,
    currentRating,
    currentReviewCount
  ) {
    const requiredFiveStar = calculateRequiredFiveStar(
      currentRating,
      currentReviewCount,
      targetRating
    );
  
    const linksToSend = calculateLinksToSend(requiredFiveStar);
  
    return {
      requiredFiveStar,
      linksToSend,
      action: `Send ${linksToSend} review links`,
    };
  }
  
  export default function MileStone() {
    const { selectedPropertyId } = useProperty();
  
    const [isLoading, setIsLoading] = useState(false);

  
    const [currentRating, setCurrentRating] = useState(-1);
    const [currentReviewCount, setCurrentReviewCount] = useState(-1);
    const [intialRating, setInitialRating] = useState(3.7);
    const [initialReviewCount, setInitialReviewCount] = useState(80);
    const [milestones, setMilestones] = useState([]);
    const [mergedStartCurrent, setMergedStartCurrent] = useState(null);
    const [isMilestoneModalOpen, setIsMilestoneModalOpen] = useState(false);
    const [placeId, setPlaceId] = useState("");
    const hasAutoCreatedRef = useRef(false);
  
   
    useEffect(() => {
      getPlaceId();
    }, []);
  
    useEffect(() => {
      if (placeId) {
        console.log("placeId", placeId);
        getReviewsMetrics();
      }
    }, [placeId]);
    useEffect(() => {
      hasAutoCreatedRef.current = false;
    }, [selectedPropertyId]);
  
    useEffect(() => {
      if (currentRating > -1 && currentReviewCount > -1) {
       
        getMileStones();
      }
    }, [currentRating, currentReviewCount]);
  
    const handleMilestoneSubmit = async (milestoneData) => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("accessToken");
  
        const res = await apiClient.post(
          `${baseUrl}/reviewMilestone/${selectedPropertyId}`,
          milestoneData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
  
        if (res.data.statusCode !== 201) return;
  
        getMileStones();
      } catch (error) {
        console.error("Error fetching milestones", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const handleOpenMilestoneModal = () => {
      // Check if there's an ongoing (upcoming) milestone
      const hasOngoingMilestone = milestones.some((m) => m.status === "Upcoming");
  
      if (hasOngoingMilestone) {
        toast.warning(
          "Your current milestone is in progress, you can set new milestone after achieved this milestone."
        );
        return;
      }
  
      setIsMilestoneModalOpen(true);
    };
  
    const getPlaceId = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("accessToken");
        const reviewsJobsResponse = await apiClient.get(
          `${baseUrl}/reviews/jobs/${selectedPropertyId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (reviewsJobsResponse.data.statusCode === 200) {
          console.log(
            "reviewsJobsResponse.data.result1",
            reviewsJobsResponse.data.result
          );
          const data = reviewsJobsResponse.data.result.reviewJobs;
          const googleItem = data.find((item) => item.network === "google");
          const googleSlug = googleItem?.slug || null;
          setPlaceId(googleSlug);
        }
      } catch (error) {
        console.error("Error fetching reviews metrics:", error);
      } finally {
        setIsLoading(false);
      }
    };
    const createStartMilestone = async () => {
      const token = localStorage.getItem("accessToken");
  
      return apiClient.post(
        `${baseUrl}/reviewMilestone/${selectedPropertyId}`,
        {
          milestoneRecord: currentRating,
          status: "Start",
          network: "google",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    };
  
    const getMileStones = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("accessToken");
  
        const res = await apiClient.get(
          `${baseUrl}/reviewMilestone/${selectedPropertyId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
  
        if (res.data.statusCode !== 200) return;
  
        const records = res.data.result.milestoneRecords;
  
        if (
          records.length === 0 &&
          currentRating > 0 &&
          !hasAutoCreatedRef.current
        ) {
          hasAutoCreatedRef.current = true;
          await createStartMilestone();
          return getMileStones();
        }
  
        // ================= NORMAL FLOW =================
  
        const start = records.find((r) => r.status === "Start");
        const achieved = records.filter((r) => r.status === "Achieved");
        const upcomingDB = records.filter((r) => r.status === "Upcoming");
  
        const baseRating = start?.milestoneRecord ?? currentRating;
        setInitialRating(baseRating);
  
        // Create merged Start/Current card
        const mergedCard = {
          startRating: baseRating,
          currentRating: currentRating,
          increase: (currentRating - baseRating).toFixed(1),
          status: currentRating > baseRating ? "Current" : "Start",
        };
        setMergedStartCurrent(mergedCard);
  
        // Organize milestones: Achieved first, then Upcoming
        const uiMilestones = [];
  
        achieved.forEach((r) => {
          uiMilestones.push({
            rating: r.milestoneRecord,
            increase: (r.milestoneRecord - baseRating).toFixed(1),
            action: "Milestone Achieved",
            status: "Achieved",
          });
        });
  
        upcomingDB.forEach((r) => {
          const calc = enrichUpcomingMilestone(
            r.milestoneRecord,
            currentRating,
            currentReviewCount
          );
  
          uiMilestones.push({
            rating: r.milestoneRecord,
            increase: (r.milestoneRecord - baseRating).toFixed(1),
            status: "Upcoming",
            ...calc,
          });
        });
  
        setMilestones(uiMilestones);
      } catch (error) {
        console.error("Error fetching milestones", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const getReviewsMetrics = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("accessToken");
        const reviewsMetricsResponse = await apiClient.get(
          `${baseUrl}/property/details?place_id=${placeId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (reviewsMetricsResponse.data.statusCode === 200) {
          console.log(
            "Review Count :- ",
            reviewsMetricsResponse.data.result.user_ratings_total
          );
          setCurrentRating(reviewsMetricsResponse.data.result.rating);
          setCurrentReviewCount(
            reviewsMetricsResponse.data.result.user_ratings_total
          );
        }
      } catch (error) {
        console.error("Error fetching reviews metrics:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    // Check if both currentRating and currentReviewCount are set
    const isDataReady = currentRating > -1 && currentReviewCount > -1;
  
    return (
    <>
     {!isDataReady || isLoading ? (
          <MilestoneSkeleton />
        ) : (
          <>
         
  
            <div className="bg-white p-5 rounded-xl shadow">
              <div className="flex justify-between items-center mb-6">
                <h3 className="font-medium text-lg flex items-center gap-2">
                  <FaStar className="text-yellow-500" /> Rating Progress &
                  Milestones
                </h3>
              </div>
  
              <div className="flex gap-4 items-start overflow-x-auto pb-2">
                {/* Merged Start/Current Card */}
                {mergedStartCurrent && (
                  <div className="rounded-xl p-4 shadow border h-[220px] bg-white border-gray-300 flex-shrink-0 w-[200px]">
                    <div className="flex flex-col h-full">
                      <p className="text-sm text-gray-700 mb-4 font-medium">
                        Start with onelyk
                      </p>
                      <div className="flex-1 space-y-3">
                        <p className="text-2xl font-bold text-yellow-600 flex items-center gap-1">
                          ⭐ {mergedStartCurrent.startRating}
                        </p>
                        <p className="text-2xl font-bold text-yellow-600 flex items-center gap-1">
                          ⭐ {mergedStartCurrent.currentRating}
                        </p>
                        <p className="text-sm text-green-600">
                          ↗ +{mergedStartCurrent.increase}
                        </p>
                      </div>
                      <div className="mt-auto pt-2">
                        <span className="text-xs px-2 py-1 rounded-full font-medium bg-blue-200 text-blue-800">
                          {mergedStartCurrent.status}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
  
                {/* Achieved and Upcoming Milestones */}
                {milestones.map((m, i) => (
                  <div key={i} className="w-[200px] flex-shrink-0">
                    <MilestoneCard data={m} />
                  </div>
                ))}
  
                {/* Start New Milestone Card */}
                <div
                  onClick={handleOpenMilestoneModal}
                  className="rounded-xl p-4 shadow border-2 border-dashed border-gray-300 h-[220px] bg-white hover:bg-gray-50 cursor-pointer transition-colors flex flex-col items-center justify-center flex-shrink-0 w-[200px]"
                >
                  <FaPlus className="text-4xl text-gray-400 mb-2" />
                  <p className="text-sm text-gray-600 font-medium text-center">
                    Start new milestone
                  </p>
                </div>
              </div>
            </div>
  
            <MilestoneModal
              isOpen={isMilestoneModalOpen}
              currentRating={currentRating}
              onClose={() => setIsMilestoneModalOpen(false)}
              onSubmit={handleMilestoneSubmit}
            />
          </>
        )}
    </>
       
   
    );
  }
  